// Global time-scale — the hitstop/slowmo family's shared mechanism. The
// frame loop multiplies simulation dt by `value`; a pulse() drops the scale
// instantly, holds it briefly, then eases back to 1. Impacts use short deep
// steps; spectacle beats (evolution, boss death) use longer gentle ramps —
// see the amoeba-game-feel skill's Time section for budgets.
//
// tick() takes REAL dt (unscaled), so recovery duration is wall-clock.

export interface TimeScale {
  readonly value: number
  /** Drop to `scale` now, hold `holdSec`, then ease back to 1 over `recoverSec`. */
  pulse(scale: number, holdSec: number, recoverSec: number): void
  tick(realDt: number): void
  reset(): void
}

export function createTimeScale(): TimeScale {
  let value = 1
  let holdRemaining = 0
  let recoverRate = 0 // scale units per second while easing back

  return {
    get value() {
      return value
    },
    pulse(scale, holdSec, recoverSec) {
      // Deeper pulses win over shallower in-flight ones.
      value = Math.min(value, Math.max(0.01, scale))
      holdRemaining = holdSec
      recoverRate = (1 - value) / Math.max(0.01, recoverSec)
    },
    tick(realDt) {
      if (holdRemaining > 0) {
        holdRemaining = Math.max(0, holdRemaining - realDt)
        return
      }
      if (value < 1) {
        value = Math.min(1, value + recoverRate * realDt)
      }
    },
    reset() {
      value = 1
      holdRemaining = 0
    },
  }
}
